/* ============================================================
   ABOUT.JS — Page-specific scripts for about.html
   ============================================================ */

// ===== GSAP INIT =====

if(!motionReduced){

  // Hero entry
  const heroTl = gsap.timeline({ delay: 0.2 });
  heroTl
    .from('.about-hero__headline', { y: 30, opacity: 0, duration: 0.6, ease: 'expo.out' })
    .from('.about-hero__sub', { y: 20, opacity: 0, duration: 0.5, ease: 'expo.out' }, '-=0.3')
    .from('.about-hero__rule', { scaleX: 0, opacity: 0, duration: 0.4, ease: 'power2.out' }, '-=0.2');

  // Our Story
  gsap.from('.about-story__label, .about-story__title, .about-story__body p', {
    y: 20, opacity: 0, stagger: 0.08, duration: 0.5, ease: 'power2.out',
    scrollTrigger: { trigger: '.about-story', start: 'top 80%' }
  });

  // Verticals grid
  gsap.from('.about-verticals__label, .about-verticals__title', {
    y: 20, opacity: 0, stagger: 0.08, duration: 0.5, ease: 'power2.out',
    scrollTrigger: { trigger: '.about-verticals', start: 'top 80%' }
  });
  gsap.from('.vertical-card', {
    y: 30, opacity: 0, stagger: 0.06, duration: 0.5, ease: 'expo.out',
    scrollTrigger: { trigger: '.about-verticals__grid', start: 'top 85%' }
  });

  // Values
  gsap.from('.about-values__label, .about-values__title', {
    y: 20, opacity: 0, stagger: 0.08, duration: 0.5, ease: 'power2.out',
    scrollTrigger: { trigger: '.about-values', start: 'top 80%' }
  });
  gsap.from('.value-item', {
    x: -20, opacity: 0, stagger: 0.08, duration: 0.5, ease: 'expo.out',
    scrollTrigger: { trigger: '.about-values__list', start: 'top 85%' }
  });

  // Bottom CTA
  gsap.from('.about-cta__heading, .about-cta__sub, .about-cta__buttons', {
    y: 20, opacity: 0, stagger: 0.08, duration: 0.5, ease: 'power2.out',
    scrollTrigger: { trigger: '.about-cta', start: 'top 80%' }
  });

} else {
  gsap.set([
    '.about-hero__headline', '.about-hero__sub', '.about-hero__rule',
    '.about-story__label', '.about-story__title', '.about-story__body p',
    '.about-verticals__label', '.about-verticals__title', '.vertical-card',
    '.about-values__label', '.about-values__title', '.value-item',
    '.about-cta__heading', '.about-cta__sub', '.about-cta__buttons'
  ].join(', '), { opacity: 1, y: 0, x: 0, scaleX: 1 });
}
